import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SharedService } from '@shared/services/shared.service';
import { IRoleEdit, ISaveUserAndRoles, IUserAndRoles, IUserAndRolesList } from 'app/models/admin/admin';
import { ISelectItems } from 'app/models/shared/shared';
import { AdminService } from 'app/services/admin/admin.service';
import { ReportsService } from 'app/services/reports/reports.service';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss']
})

export class UsersComponent implements OnInit {

  countySelected: string = '';
  countyList: ISelectItems[] = [];
  searchList: IUserAndRolesList[] = [];
  resultsCount: number = 0;
  filter: string = '';
  rolesList: IRoleEdit[] = [];
  currentUser: IUserAndRoles;
  currentUserRoles: string[] = [];

  newUsersFlag: boolean = false;
  showSearchList: boolean = false;
  editUser: boolean = false;
  selectedCounties: string[] = [];

  displayedColumns: string[] = ['email', 'lastName', 'firstName', 'enabled', 'fipsCountyId', 'roles',
    'actions'];
  dataSource = new MatTableDataSource<IUserAndRolesList>(this.searchList);

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public adminService: AdminService,
    public sharedService: SharedService,
    // private modalService: MatDialog,
    public reportService: ReportsService) { }

  form = new UntypedFormGroup({
    searchText: new UntypedFormControl('', [Validators.maxLength(50)]),
  });

  userForm = new UntypedFormGroup({
    enabled: new UntypedFormControl(''),
    email: new UntypedFormControl({ value: '', disabled: true }, [Validators.email, Validators.required]),
    firstName: new UntypedFormControl('', [Validators.required]),
    lastName: new UntypedFormControl('', [Validators.required])
  });

  ngOnInit(): void {
    this.showSearchList = false;
    this.editUser = false;
    this.searchList = [];
    this.selectedCounties = [];
    this.currentUserRoles = [];
    this.countyList = this.sharedService.countyDropDownList;
    this.rolesList = [];
    if (this.adminService.userSearch != '') {
      this.form.controls['searchText'].setValue(this.adminService.userSearch);
      this.getUserData();
    }
    this.getRoles();
    this.newUsersFlag = false;
  }

  getRoles() {
    this.adminService.getRoles().subscribe({
      next: response => {
        this.rolesList = response;
      },
      error: e => {
        this.sharedService.toastr.error("Could not get Role Data");
      },
    });
  }

  search() {  
    this.newUsersFlag = false;
    this.getUserData();
  }

  getUserData() {
    this.searchList = [];
    let searchText = String(this.form.controls['searchText'].value);
    if (searchText != null && searchText != '' && searchText.length < 3) {
      this.sharedService.toastr.error("Search text must be at least 3 characters or blank to get all records");
    }
    else {
      this.adminService.userSearch = this.adminService.userSearch != null &&
        this.adminService.userSearch != '' ? this.adminService.userSearch :
        String(this.form.controls['searchText'].value);


      let newUser = this.newUsersFlag ? 'true' : 'false';
      searchText = searchText == null || searchText == '' ? 'NULL' : searchText;
      this.adminService.getUsersList(newUser, searchText).subscribe({
        next: response => {
          response.forEach(x=> {
            let item:IUserAndRolesList = {
              id: x.user.id,
              email: x.user.email,
              firstName: x.user.firstName,
              lastName: x.user.lastName,
              fipsCountyId: x.user.fipsCountyId,
              enabled: x.user.enabled,
              userAndRole: x
            };
            this.searchList.push(item);
          })
          this.adminService.userSearch = searchText == 'NULL' ? '' : searchText;
          this.dataSource.data = this.searchList;
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          if (response != null) {
            this.resultsCount = this.searchList.length;
          }
        },
        error: e => {
          this.sharedService.toastr.error("Could not get Business Data");
        },
      });
    }
  }

  rowClick(row: IUserAndRoles) {
    this.editUser = true;
    this.currentUser = row;
    this.currentUserRoles = row.roles;
    this.userForm.controls['enabled'].setValue(row.user.enabled);
    this.userForm.controls['email'].setValue(row.user.email);
    this.userForm.controls['firstName'].setValue(row.user.firstName);
    this.userForm.controls['lastName'].setValue(row.user.lastName);
    this.selectedCounties = row.user.fipsCountyId != null && row.user.fipsCountyId.length > 0? row.user.fipsCountyId.split(',') : [];
  }

  countyListing(fipsIds: string): string[] {
    let county = fipsIds.split(',');
    return county;
  }

  county(countyId: string): string {
    let county = this.countyList.find(c => c.value == countyId);
    return county == null ? '' : county.text;
  }

  filterTable(event: Event) {
    this.dataSource.filter = (event.target as HTMLInputElement).value.trim().toLocaleLowerCase();
    this.filter = this.dataSource.filter;
  }

  deleteUser(user: IUserAndRoles) {
    this.sharedService.openConfirm("Are you sure you want to delete this user?");

    this.sharedService.confirmed().subscribe(
      confirmed => {
        this.adminService.deleteUser(user.user.id).subscribe({
          next: response => {
            this.sharedService.toastr.success("Deleted User Data");
            this.getUserData();
            this.editUser = false;
          },
          error: e => {
            this.sharedService.toastr.error("Delete Failed. Please try again.");
          },
        });
      }
    );
  }

  newUsers() {
    this.newUsersFlag = true;
    this.getUserData();
  }

  check(county: string, event: any) {
    if (event.checked) {
      this.selectedCounties.push(county);
    }
    else {
      this.selectedCounties = this.selectedCounties.filter(x => x != county);
    }
  }

  checkRole(role: string, event: any) {
    if (event.checked) {
      this.currentUserRoles.push(role);
    }
    else {
      this.currentUserRoles = this.currentUserRoles.filter(x => x != role);
    }
  }

  roleChecked(role: string): boolean {
    return this.currentUserRoles.includes(role);
  }

  countyChecked(county: string): boolean {
    return this.selectedCounties.includes(county);
  }

  cancel() {
    this.editUser = false;
  }

  saveUser() {
    if (this.userForm.valid) {

      let value: ISaveUserAndRoles = {
        id: this.currentUser.user.id,
        email: this.userForm.controls['email'].value,
        enabled: this.userForm.controls['enabled'].value,
        firstName: this.userForm.controls['firstName'].value,
        lastName: this.userForm.controls['lastName'].value,
        fipsCountyId: this.selectedCounties.join(','),
        roles: this.currentUserRoles
      };

      this.adminService.saveUser(value).subscribe({
        next: response => {
          this.sharedService.toastr.success("Saved User Data");
          this.getUserData();
          this.editUser = false;
        },
        error: e => {
          this.sharedService.toastr.error("Save Failed. Please try again.");
        },
      });
    }
  }

}
